import React from 'react';

export const Cookies = () => {
  return (
    <div className="min-h-screen pt-32 pb-20">
      <div className="container mx-auto px-5 md:px-10">
        <div className="max-w-4xl mx-auto">
          <h1 className="heading-1 text-text-primary mb-6">COOKIE POLICY</h1>
          <p className="body-small text-text-secondary mb-12">Last updated: {new Date().toLocaleDateString()}</p>

          <div className="space-y-8">
            <section>
              <h2 className="heading-4 text-text-primary mb-4">1. What Are Cookies</h2>
              <p className="body-medium text-text-secondary mb-4">
                Cookies are small text files that are placed on your device when you visit our website. They help us provide you with a better experience and allow certain features to function properly.
              </p>
            </section>

            <section>
              <h2 className="heading-4 text-text-primary mb-4">2. How We Use Cookies</h2>
              <p className="body-medium text-text-secondary mb-4">
                Opti Flo Apps Ltd uses cookies for various purposes:
              </p>
              <ul className="space-y-2 ml-6">
                <li className="body-medium text-text-secondary">• <strong className="text-text-primary">Essential Cookies:</strong> Required for the website to function properly</li>
                <li className="body-medium text-text-secondary">• <strong className="text-text-primary">Analytics Cookies:</strong> Help us understand how visitors interact with our website</li>
                <li className="body-medium text-text-secondary">• <strong className="text-text-primary">Functional Cookies:</strong> Enable enhanced functionality and personalization</li>
                <li className="body-medium text-text-secondary">• <strong className="text-text-primary">Advertising Cookies:</strong> Used to deliver relevant advertisements</li>
              </ul>
            </section>

            <section>
              <h2 className="heading-4 text-text-primary mb-4">3. Types of Cookies We Use</h2>
              
              <div className="space-y-4">
                <div className="bg-bg-card border border-border-medium p-6">
                  <h3 className="heading-6 text-text-primary mb-2">Session Cookies</h3>
                  <p className="body-small text-text-secondary">
                    These are temporary cookies that expire when you close your browser. They help us maintain your session as you navigate through our website.
                  </p>
                </div>

                <div className="bg-bg-card border border-border-medium p-6">
                  <h3 className="heading-6 text-text-primary mb-2">Persistent Cookies</h3>
                  <p className="body-small text-text-secondary">
                    These cookies remain on your device for a set period or until you delete them. They help us remember your preferences and provide a more personalized experience.
                  </p>
                </div>

                <div className="bg-bg-card border border-border-medium p-6">
                  <h3 className="heading-6 text-text-primary mb-2">Third-Party Cookies</h3>
                  <p className="body-small text-text-secondary">
                    We may use services from third-party providers that set their own cookies. These help with analytics, advertising, and other functions.
                  </p>
                </div>
              </div>
            </section>

            <section>
              <h2 className="heading-4 text-text-primary mb-4">4. Managing Cookies</h2>
              <p className="body-medium text-text-secondary mb-4">
                You can control and manage cookies in various ways:
              </p>
              <ul className="space-y-2 ml-6">
                <li className="body-medium text-text-secondary">• <strong className="text-text-primary">Browser Settings:</strong> Most browsers allow you to refuse or accept cookies through their settings</li>
                <li className="body-medium text-text-secondary">• <strong className="text-text-primary">Delete Cookies:</strong> You can delete cookies that have already been set</li>
                <li className="body-medium text-text-secondary">• <strong className="text-text-primary">Opt-Out Tools:</strong> Use industry opt-out tools for advertising cookies</li>
              </ul>
              <p className="body-medium text-text-secondary mt-4">
                Please note that disabling cookies may affect the functionality of our website and limit your user experience.
              </p>
            </section>

            <section>
              <h2 className="heading-4 text-text-primary mb-4">5. Cookie Duration</h2>
              <p className="body-medium text-text-secondary mb-4">
                The duration of cookies varies depending on their purpose:
              </p>
              <ul className="space-y-2 ml-6">
                <li className="body-medium text-text-secondary">• Session cookies: Deleted when you close your browser</li>
                <li className="body-medium text-text-secondary">• Persistent cookies: Typically last from a few days to several years</li>
                <li className="body-medium text-text-secondary">• Third-party cookies: Duration set by the third-party provider</li>
              </ul>
            </section>

            <section>
              <h2 className="heading-4 text-text-primary mb-4">6. Updates to This Policy</h2>
              <p className="body-medium text-text-secondary mb-4">
                We may update this Cookie Policy from time to time to reflect changes in technology, legislation, or our business operations. We encourage you to review this policy periodically.
              </p>
            </section>

            <section>
              <h2 className="heading-4 text-text-primary mb-4">7. More Information</h2>
              <p className="body-medium text-text-secondary mb-4">
                For more information about how we use your data, please see our Privacy Policy. If you have questions about our use of cookies, please contact us:
              </p>
              <p className="body-medium text-text-primary">
                Email: <a href="mailto:contact@optiflo.app" className="text-brand-primary hover:underline">contact@optiflo.app</a>
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};